<div #wrapper class="wrapper">
  <img class="image" [src]="wasOnceVisible ? src : ''">
</div>
